<template>
    <v-container  class="h-100 " >
        <v-row no-gutters class="h-100">
            <v-col class="h-100" style="overflow-y: scroll">
                <v-data-table
                        :headers="fields"
                        :items-per-page="Items.length"
                        :items="Items"
                        item-key="id"
                        no-data-text="Нет элементов"
                        no-results-text="Не найдено"
                        loading-text="Загрузка данных"
                        calculate-widths
                        class="elevation-1"
                        :search="search"
                        fixed-header
                        sort-by="requestDateTime"
                        sort-desc
                        hide-default-footer
                        @click:row="showDetailModal"
                >
                    <template v-slot:item.isRead="{ item }">
                        <div v-if="item.isRead==false" class="markNotRead"></div>
                    </template>
                    <template v-slot:item.requestNumber="{ item }">
                        <span :class="{'readRow':item.isRead, 'newRow':true}"> {{item.requestNumber}}</span>
                    </template>
                    <template v-slot:item.carName="{ item }">
                        <span :class="{'readRow':item.isRead,'text-truncate':true, 'newRow':true}"> {{ item.carMarkName+' '+item.carModelName +', '+ item.carYear}}</span>
                    </template>
                    <template v-slot:item.webUser="{ item }">
                        <span :class="{'readRow':item.isRead, 'newRow':true}"> {{ item.webUser }}</span>
                    </template>
                    <template v-slot:item.requestDateTime="{ item }">
                        <span :class="{'readRow':item.isRead, 'newRow':true}"> {{ formatTimeDateMounthName(item.requestDateTime) }}</span>
                    </template>
                    <template v-slot:item.clientFullName="{ item }">
                        <span :class="{'readRow':item.isRead, 'newRow':true}"> {{ item.clientFullName }}</span>
                    </template>
                    <template v-slot:item.requestCategoryName="{ item }">
                        <span :class="{'readRow':item.isRead,  'newRow':true}"> {{ item.requestCategoryName }}</span>
                    </template>
                    <template v-slot:item.requestStatus="{ item }">
                        <span :class="{'readRow':item.isRead, 'newRow':true, 'processed-answer':item.requestAnswerStatusCode=='AS07', 'client-answer':item.requestAnswerStatusCode=='AS05'}"> {{ item.requestStatus }}</span>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <detailsModal :show="showDetail" :detailedItem="detailedItem" @close="closeDetails"></detailsModal>
    </v-container>
</template>

<script>
    const detailsModal =()=> import('./DetailsRequest.vue')
    export default {
        name: "RequestActive",
        components:{detailsModal},
        props:{
            search:String
        },
        data(){
            return{
                loading:false,
                fields: [
                    {text: '№', value: 'requestNumber', width: "50px"},
                    {text: 'Создана', value: 'requestDateTime',width: "185px"},
                    {text: 'S', value: 'isRead', filterable: false, width: "50px", align: "center"},
                    {text: 'Клиент', value: 'clientFullName',width: "250px"},
                    {text: 'Транспортное средство', value: 'carName', width: "200px"},
                    {text: 'Категория заявки', value: 'requestCategoryName'},
                    {text: 'Тема обращения', value: 'serviceType'},
                    {text: 'Принял', value: 'webUser'},
                    {text: 'Статус', value: 'requestStatus'},
                ],
                showDetail:false,
                detailedItem:null,
            }
        },
        beforeMount() {
            this.loadData()
        },
        computed:{
            Items() {
                var items = this.$store.state.Requests.activeRequests;
                if (items != null) {
                    return items
                }
                else return [];
            },
        },
        methods:{
            loadData(){
                const vm=this
                this.loading=true
                this.$store.dispatch("Requests/getActiveRequests").then(()=>vm.loading=false)
                    .catch(err => {
                        vm.loading=false
                        this.$bvToast.toast(err.message, {
                            title: `Ошибка загрузки списка заявок!`,
                            variant: "danger",
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 3000,
                            solid: true
                        })
                    })
            },


            closeDetails(isSave){
                this.showDetail=false
                if(isSave){
                    this.loadData()
                }
            },
            showDetailModal(e) {
                this.detailedItem = e;
                this.showDetail = true;
                //отправляем запрос на прочтение
                if (e.isRead == false) {
                    this.$store.dispatch("Requests/markReadRequest", e.id).catch(err => {
                        console.log("Ошибка прочтения заявки!")
                    })
                }
            },

        }
    }
</script>

<style scoped>
    .newRow{
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
    }
    .readRow{
        color:var(--color-2);
    }

    .processed-answer{
        color:#27AE60;
    }

    .client-answer{
        color: #CAA41E;
    }
</style>